import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer
      className="relative bg-walnut text-cream overflow-hidden"
      data-testid="footer"
    >
      {/* Massive brand mark */}
      <div className="relative px-6 md:px-12 lg:px-20 pt-20 pb-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid lg:grid-cols-12 gap-10 pb-16 border-b border-cream/10">
            <div className="lg:col-span-5">
              <div className="font-serif text-4xl md:text-5xl italic-serif font-light mb-4">
                Yogi Market
              </div>
              <p className="text-sm text-cream/70 max-w-sm leading-relaxed">
                1<sup>re</sup> boutique dédiée aux handpans, gongs et instruments
                de sonothérapie à Compiègne. Partenaire officiel SoundYoga.
              </p>
            </div>
            <div className="lg:col-span-3">
              <h4 className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-4">
                Navigation
              </h4>
              <ul className="space-y-2.5 text-sm">
                <li><a href="#showcase" className="hover:text-terracotta transition" data-testid="footer-nav-showcase">Instruments</a></li>
                <li><a href="#shop" className="hover:text-terracotta transition" data-testid="footer-nav-shop">Boutique</a></li>
                <li><a href="#partner" className="hover:text-terracotta transition" data-testid="footer-nav-partner">SoundYoga</a></li>
                <li><a href="#contact" className="hover:text-terracotta transition" data-testid="footer-nav-contact">Contact</a></li>
              </ul>
            </div>
            <div className="lg:col-span-4">
              <h4 className="text-xs uppercase tracking-[0.25em] text-cream/50 mb-4">
                Boutique
              </h4>
              <ul className="space-y-2.5 text-sm text-cream/80">
                <li>17 rue de Pierrefonds, 60200 Compiègne</li>
                <li>
                  <a href="tel:+33767396699" className="hover:text-terracotta transition" data-testid="footer-phone">07 67 39 66 99</a>
                </li>
                <li>
                  <a href="mailto:contact@soundyoga.fr" className="hover:text-terracotta transition" data-testid="footer-email">contact@soundyoga.fr</a>
                </li>
              </ul>
            </div>
          </div>

          {/* Giant brand text */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
            className="py-16 text-center"
          >
            <div className="font-serif text-[18vw] lg:text-[14vw] leading-[0.8] font-light text-cream/10 select-none">
              yogi<span className="italic-serif text-terracotta/30">market</span>
            </div>
          </motion.div>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 border-t border-cream/10 text-xs text-cream/50">
            <div>© {new Date().getFullYear()} Yogi Market Compiègne · Tous droits réservés.</div>
            <div className="flex items-center gap-6">
              <span>Fabriqué en France 🇫🇷</span>
              <span>·</span>
              <a href="#top" className="hover:text-terracotta transition" data-testid="back-to-top">
                Retour en haut ↑
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
